<!-- @format -->

<template>
	<div class="pc-cpt-image">
		<el-upload :file-list="fieldList" class="pc-cpt-image-show-list" list-type="picture-card">
			<template #file="{ file }">
				<div>
					<img class="el-upload-list__item-thumbnail" :src="file.url" alt="" />
					<span class="el-upload-list__item-actions">
						<span class="el-upload-list__item-preview" @click="onPreview(file)">
							<el-icon><zoom-in /></el-icon>
						</span>
						<span v-if="!disabled" class="el-upload-list__item-delete" @click="onRemove(file)">
							<el-icon><Delete /></el-icon>
						</span>
					</span>
				</div>
			</template>
		</el-upload>

		<div v-if="!disabled && isShowAddIcon" class="el-upload--picture-card" @click="onShowUploader">
			<el-icon><Plus /></el-icon>
		</div>

		<pcp-uploader-image
			v-if="uploaderVisable"
			:visible="uploaderVisable"
			v-bind="$attrs"
			@action-event="uploaderAction"
			@close="(visible) => (uploaderVisable = visible)"
		/>

		<pc-dialog
			v-model="previewStatus.visabeld"
			:show-footer="false"
			width="400px"
			@on-close="previewStatus.visabeld = false"
		>
			<img w-full :src="previewStatus.url" alt="" style="width: 100%" />
		</pc-dialog>
	</div>
</template>

<script setup lang="ts">
	import { getImgUrl } from './utils';
	import { PcpUploaderImage } from '@/p-components/pcp-uploader-image/index';

	interface Props {
		modelValue: string;
		disabled?: boolean;
		limit: number;
	}

	const props = withDefaults(defineProps<Props>(), {});

	const emits = defineEmits(['update:modelValue']);

	const value = computed({
		get() {
			return props.modelValue ? props.modelValue.split(',') : [];
		},
		set(val) {
			emits('update:modelValue', val ? val.join(',') : '');
		},
	});

	const fieldList = computed(() => value.value.map((id) => ({ name: '', url: getImgUrl(id), id })));

	const uploaderVisable = ref(false);

	const previewStatus = ref({
		visabeld: false,
		url: '',
	});

	const isShowAddIcon = computed(() => !props.limit || value.value.length < props.limit);

	const onShowUploader = () => {
		uploaderVisable.value = true;
	};

	const uploaderAction = (key: string, data: string[]) => {
		if (key == 'confirm') {
			uploaderVisable.value = false;
			value.value = [...value.value, ...data];
		}
	};

	const onPreview = (file) => {
		previewStatus.value = {
			visabeld: true,
			url: file.url,
		};
	};

	const onRemove = (file) => {
		const val = value.value.filter((id) => id !== file.id);
		value.value = val;
	};
</script>

<style scoped lang="scss">
	.pc-cpt-image {
		display: flex;

		.pc-cpt-image-show-list {
			:deep(.el-upload--picture-card) {
				display: none;
			}
		}
	}

	:deep(.el-upload--picture-card) {
		border-radius: 1px;
	}

	:deep(.el-upload-list--picture-card .el-upload-list__item) {
		border-radius: 1px;
	}
</style>
